import { Button } from "@/shared/components/ui/button";
import { Download } from "lucide-react";
import { useDownloadPdf } from "@/shared/lib/utilities/download-pdf";
import { useToast } from "@/shared/hooks/use-toast";
import { useEffect } from "react";
import { parseRTKQueryError } from "@/shared/components/errors/parse-r-t-k-query-error";
import {
  ConfirmationDocument,
  useRltConfirmationPdfDownloadMutation,
} from "@/services/backend/rlt/confirmations/api/confirmation-api";

export function DownloadButton({
  confirmationId,
  document: documentType,
  text,
}: {
  confirmationId: string;
  document: ConfirmationDocument;
  text: string;
}) {
  const [download, { isLoading, error, data, reset }] =
    useRltConfirmationPdfDownloadMutation();
  const { toast } = useToast();

  useDownloadPdf(data, reset);

  useEffect(() => {
    if (error) {
      toast({
        ...parseRTKQueryError(error),
        variant: "destructive",
      });
    }
  }, [toast, error]);

  const doDownload = () => {
    if (isLoading) {
      return;
    }

    download({ id: confirmationId, document: documentType });
  };

  return (
    <Button variant="outline" className="justify-start" onClick={doDownload}>
      {isLoading ? (
        <Download className="mr-4 h-5 w-5 animate-bounce" />
      ) : (
        <Download className="mr-4 h-5 w-5" />
      )}
      <span>{text}</span>
    </Button>
  );
}
